var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chatbot_wrap",on:{"click":_vm.clickHandle}},[_c('i',{staticClass:"iconfont iconduihuaxiaozhi icon-chatbot"})])}
var staticRenderFns = []

export { render, staticRenderFns }